import './App.css';
import Cart from './components/Cart/Cart';
import Contact from './components/Contact/Contact';
import Delivery from './components/Delivery/Delivery';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Offers from './components/Offers/Offers';
import Products from './components/Products/Products';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <CartProvider>
      <div className="App">
        <Header />
        <Hero />
        <Products />
        <Offers />
        <Delivery />
        <Contact />
        <Footer />
        <Cart />
      </div>
    </CartProvider>
  );
}

export default App;